import React from 'react';
export const TimelineSection = () => {
  return <section className="w-full bg-white px-5 py-10" data-id="element-191">
      <div className="max-w-md mx-auto" data-id="element-192">
        <div className="bg-pink-50 rounded-xl p-6 mb-8 shadow-sm" data-id="element-193">
          <div className="w-full rounded-xl overflow-hidden shadow-sm mb-7" data-id="element-194">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6WSt7aDMKa8v3tToyJHSXK/f1bb0b1d-8fec-4bfd-ba79-e89fb1d25650.png" alt="Nuora Feminine Balance Gummies" className="w-full h-auto object-cover" data-id="element-195" />
          </div>
          <h2 className="text-2xl font-bold text-pink-900 mb-7 leading-tight" data-id="element-196">
            Your 90-Day Rehydration Timeline
          </h2>
          <div className="space-y-5" data-id="element-197">
            <TimelineItem weeks="1–2" description="Daily irritation and friction begin to fade. Comfort improves." data-id="element-198" />
            <TimelineItem weeks="3–4" description="Your body's natural moisture production begins to reactivate. Less reliance on lubricants." data-id="element-199" />
            <TimelineItem weeks="5–8" description="Vaginal tissue feels more resilient and plump. Intimacy becomes pleasurable, not painful." data-id="element-200" />
            <TimelineItem weeks="9–12" description="Your internal ecosystem is restored. You feel comfortable, confident, and hydrated from within." data-id="element-201" />
          </div>
          <a href="https://mynuora.com/products/feminine-balance-gummies-1" target="_blank" rel="noopener noreferrer" data-id="element-202">
            <button className="bg-pink-600 hover:bg-pink-700 transition-colors text-white font-bold py-4 px-6 rounded-full w-full mt-7 shadow-md" data-id="element-203">
              GET NUORA GUMMIES NOW
            </button>
          </a>
        </div>
      </div>
    </section>;
};
interface TimelineItemProps {
  weeks: string;
  description: string;
}
const TimelineItem = ({
  weeks,
  description
}: TimelineItemProps) => {
  return <div className="flex items-stretch" data-id="element-204">
      <div className="w-24 flex-shrink-0" data-id="element-205">
        <div className="bg-pink-200 rounded-lg p-2 mr-4 h-full flex items-center justify-center" data-id="element-206">
          <p className="text-pink-800 font-bold text-center" data-id="element-207">Weeks {weeks}</p>
        </div>
      </div>
      <div className="bg-white rounded-xl p-4 flex-grow shadow-sm flex items-center" data-id="element-208">
        <p className="text-gray-700 leading-relaxed" data-id="element-209">{description}</p>
      </div>
    </div>;
};